import { SavedQuery, UUID } from '@/types';
import { rootDomain } from './helpers/essential-helpers';
import CategoryRef from './CategoryRef';

class ViewRef {
  constructor(
    readonly _id: Maybe<UUID>,
    readonly _name: string,
    readonly _series: UUID,
    readonly _saved: Maybe<string>,
    readonly _categories: Maybe<CategoryRef[]>,
  ) {}

  static build(serverObj: ViewRef) {
    return new ViewRef(
      serverObj._id,
      serverObj._name,
      serverObj._series,
      serverObj._saved,
      serverObj._categories &&
        serverObj._categories.map((cat) => CategoryRef.build(cat)),
    );
  }

  static fromSavedQuery = (query: SavedQuery) =>
    new ViewRef(query.id, query.name, query.series, query.createdAt, undefined);

  id() {
    return this._id;
  }

  name() {
    return this._name;
  }

  series() {
    return this._series;
  }

  saved() {
    return this._saved;
  }

  downloadPrefix() {
    return `${rootDomain()}/share/view/${this.series()}/`;
  }

  downloadSuffix() {
    return this.name().replace(/[^A-Za-z0-9_]+/gi, '_');
  }

  categories() {
    return this._categories;
  }

  equals(v: Nullable<ViewRef>) {
    if (!v) {
      return false;
    }

    if (!(v instanceof ViewRef)) {
      return false;
    }

    return this.id() === v.id();
  }

  uniqueName() {
    return this.name();
  }
}

export default ViewRef;
